@import '~style-sheet-helpers/core.less';
@import (reference) '../settings-page.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

@width230: 230px;

.settings-section {
  &:extend(.settings-section all);
  max-width: none;
  font-size: 16px;
  overflow: auto;
}

.subtext {
  font-size: 16px;
  margin-bottom: @space-24;
  line-height: 1.3;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;

  .add-button {
    padding: 8px;
    display: flex;
    align-items: center;
  }
}

.pickup-settings-schedule {
  display: grid;
  grid-template-columns: 60px 150px;
  align-items: start;
  row-gap: 5px;
  margin-bottom: 5px;
}

.no-schedule-warning {
  padding: 5px 10px 5px 0;
  .child-wrapper {
    font-size: 12px;
  }
}

.grid-wrapper {
  .grid();
  grid-template-columns: auto auto auto auto auto;
  margin-top: 20px;

  &.grid-with-schedule {
    grid-template-columns: auto auto auto auto auto auto;
  }

  .left-head-cell {
    .left-header-cell();
  }

  .head-cell {
    .header-cell();
    text-align: left;
  }

  .right-head-cell {
    .right-header-cell();
    text-align: center;
  }

  .left-cell {
    .left-grid-cell();
    word-break: break-all;
    span {
      padding-left: 0;
    }
  }

  .cell {
    .grid-cell();
    text-align: left;
    width: auto;

    .address {
      word-wrap: break-word;
      width: auto;
    }
  }

  .empty-state-cell {
    grid-column: 1 / -1;
    padding: @space-12;
    text-align: center;
  }

  .pickup-settings-cell {
    .cell;
    width: 210px;
  }

  .right-cell {
    .right-grid-cell();
  }

  .pill {
    background-color: @seller-setting--pill--background-color;
    border: 1px solid @seller-setting--pill--border-color;
    padding: 2px @space-8;
    margin-top: @space-4;
    color: @seller-setting--pill--text-color;
    font-size: 12px;
    line-height: 16px;
  }
}

.icon {
  height: 10px;
  width: 10px;
  margin-right: 5px;
}

.delete-ship-from-modal-body {
  padding: 32px 16px 50px;
  width: 600px;
}

.menu-toggle {
  height: 40px;
  width: 40px;
  margin-top: -5px;
  border-radius: 6px;
  color: @settings-page--shipping-ship-from-menu--text-color;

  &:hover,
  &:focus {
    background-color: @settings-page--shipping-ship-from-menu--hover--background-color;
    color: @settings-page--shipping-ship-from-menu--hover--text-color;
  }

  &:active {
    background-color: @settings-page--shipping-ship-from-menu--active--background-color;
    color: @settings-page--shipping-ship-from-menu--active--text-color;
  }
}

.danger {
  color: @settings-page--shipping-ship-from-delete--text-color;
}

.open-menu-toggle {
  background-color: @settings-page--shipping-ship-from-open-menu--background-color;
  color: @settings-page--shipping-ship-from-open-menu--text-color;
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    width: 16px;
  }
}

.pickup-settings-wrapper {
  height: 100%;
  padding-right: 0;
  padding-bottom: 0;

  H2.pickup-settings-title {
    line-height: 30px;
    margin-bottom: 0;
    padding-bottom: 9px;
    font-weight: 400;
  }

  .edit-pickup-settings-page {
    display: flex;
    height: 100%;

    .pickup-info-wrapper {
      padding: 16px 16px 16px 0;
      border-top: 1px @settings-page--shipping-ship-from--border-color solid;
      width: 100%;

      .input-section-wrapper {
        margin-bottom: 12px;

        &.pickup-contact-wrapper,
        &.preferred-pickup-time-wrapper {
          width: @width230;
        }

        &.available-hours-wrapper {
          width: 470px;
        }

        .day-checkbox-wrapper {
          &.inline {
            display: inline-block;
          }

          &.row {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
          }

          .checkbox {
            margin-right: 18px;
            font-size: 14px;
            min-width: 50px;
          }
        }

        .start-time {
          padding-right: 10px;
        }

        .end-time {
          padding-left: 10px;
          margin-right: 16px;
        }

        .same-schedule-checkbox {
          display: inline-block;
        }
      }

      .carrier-instructions-wrapper {
        margin-bottom: 24px;
        max-width: 448px;
      }

      .label {
        font-size: 14px;
        font-weight: 500;
        padding-bottom: 4px;
        display: block;

        &.error {
          color: @settings-page--shipping-ship-from-label--error--text-color;
        }

        .subtext {
          padding-left: 4px;
          color: @settings-page--shipping-ship-from-label--text-color;
          font-size: 12px;
          padding-bottom: 4px;
        }
      }

      .full-row-dd {
        width: @width230;
      }

      .action-button-menu {
        border-top: 1px @settings-page--shipping-ship-from--border-color solid;
        padding: 13px 8x 8px;

        .button {
          margin-right: 8px;
        }
      }
    }

    .ship-from-section {
      display: flex;
      flex-direction: column;
      padding: 16px;
      border: 1px solid @settings-page--shipping-ship-from--border-color;
      border-top: 1px @settings-page--shipping-ship-from--border-color solid;
      border-bottom: none;
      background: @settings-page--shipping-ship-from-section--background-color;
      font-size: 12px;
      color: @settings-page--shipping-ship-from-section--text-color;
      line-height: 1.5;
      min-width: 272px;

      .title {
        color: @settings-page--shipping-ship-from-section-title--text-color;
        padding-bottom: 4px;
        margin: 0;
        &.warehouse {
          line-height: 25px;
          font-weight: 400;
        }
        &.contact {
          font-size: 16px;
          line-height: 22px;
          margin-top: 16px;
        }
      }

      .link {
        font-size: 12px;
        text-align: left;
        padding-top: 4px;

        &.extra-padding {
          padding-top: 16px;
        }

        .link-icon {
          height: 12px;
          width: auto;
          margin-left: 5px;
        }
      }
    }
  }
}

.unstyled-link {
  color: @settings-page--shipping-ship-from-link--text-color;
  &:hover {
    text-decoration: none;
  }
}
